import React from 'react';

import { TestManagementMobileBanner } from '../../../../assets/images';
import { IconArrowForward } from '../../../../assets/icons/icon';
import './test-management-banner.scss';

const MobileTestManagementBanner = () => {
  return (
    <section className="m-test-management-banner">
      <img src={TestManagementMobileBanner} alt="" />
      <div className="banner-title">
        <h1 className="divider-24">akaAT Test Management</h1>
        <p className="divider-32">
          Work smarter together with akaAT <br />
          {`{collaborative test management tool}`}.
        </p>
        <a href={`https://akaat.com/wiki/`} target={'_blank'} rel="noreferrer">
          <button className=" divider-60">
            Get started
            <IconArrowForward style={{ marginLeft: '8px' }} />
          </button>
        </a>
      </div>
    </section>
  );
};

export default MobileTestManagementBanner;
